module.exports = __webpack_public_path__ + "img/No_image_available.e67b0bc7.svg";